export const allowedTenantIds: string[] =
  (process.env.REACT_APP_ALLOWED_TENANTS || "")
    .split(",")
    .map(t => t.trim())
    .filter(Boolean);